import { openWindow } from './openWindow'
import { openLoginWindow } from './openLoginWindow'

export const BrowserUtils = {
  openWindow,
  openLoginWindow,
}
